function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.3137 3H5.06275C3.98524 3 2.95186 3.42804 2.18995 4.18995C1.42804 4.95186 1 5.98524 1 7.06275V39.5647C1 40.6422 1.42804 41.6756 2.18995 42.4375C2.95186 43.1994 3.98524 43.6275 5.06275 43.6275H29.4392C30.5167 43.6275 31.5501 43.1994 32.312 42.4375C33.0739 41.6756 33.502 40.6422 33.502 39.5647V15.1882",
  stroke: "#E6E6E6",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.376 25.3438H9.125",
  stroke: "#E6E6E6",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17 32H9",
  stroke: "#E6E6E6",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 33.8463,
  cy: 38.3678,
  r: 12.6314,
  fill: "#111214"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M34.1848 46.6312C38.5595 46.6312 42.1058 43.0848 42.1058 38.7101C42.1058 34.3355 38.5595 30.7891 34.1848 30.7891C29.8101 30.7891 26.2637 34.3355 26.2637 38.7101C26.2637 43.0848 29.8101 46.6312 34.1848 46.6312Z",
  stroke: "#5779FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M34.1855 33.957V38.7097L37.354 40.2939",
  stroke: "#5779FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M35.25 6.33501C35.2507 6.21986 35.2286 6.1057 35.1851 5.9991C35.1415 5.89249 35.0774 5.79553 34.9963 5.71376L31.2863 2.00376C31.2045 1.92267 31.1075 1.85851 31.0009 1.81496C30.8943 1.77142 30.7802 1.74935 30.665 1.75001C30.5499 1.74935 30.4357 1.77142 30.3291 1.81496C30.2225 1.85851 30.1255 1.92267 30.0438 2.00376L27.5675 4.48001L18.0038 14.0438C17.9227 14.1255 17.8585 14.2225 17.815 14.3291C17.7714 14.4357 17.7493 14.5499 17.75 14.665V18.375C17.75 18.6071 17.8422 18.8296 18.0063 18.9937C18.1704 19.1578 18.393 19.25 18.625 19.25H22.335C22.4575 19.2567 22.5799 19.2375 22.6945 19.1938C22.809 19.1501 22.9131 19.0828 23 18.9963L32.5113 9.43251L34.9963 7.00001C35.0761 6.91521 35.1412 6.81761 35.1888 6.71126C35.1972 6.64152 35.1972 6.57101 35.1888 6.50126C35.1929 6.46053 35.1929 6.4195 35.1888 6.37876L35.25 6.33501ZM21.9763 17.5H19.5V15.0238L28.1888 6.33501L30.665 8.81126L21.9763 17.5ZM31.8988 7.57751L29.4225 5.10126L30.665 3.86751L33.1325 6.33501L31.8988 7.57751Z",
  fill: "#E6E6E6"
});

function SvgContratoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 51,
    viewBox: "0 0 47 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContratoIcon);
export default __webpack_public_path__ + "static/media/contrato-icon.c19654a4f4689e4f62a30bf29f22f0d3.svg";
export { ForwardRef as ReactComponent };